import { AxiosInstance } from 'axios';
import BugReportRepositoryInterface from '@/services/Bug-report/Bug-report/interfaces';
import {
  BugReportEntity,
  CreateBugReportRequestDTO,
  UpdateBugReportDTO,
  BugReportFiltersDTO,
  BugReportFilesConfig,
} from "@fenix/bug-report-entities/bug-report-entities";
import {FeatureRequestEntity} from "@fenix/bug-report-entities";

export default class BugReportRepository implements BugReportRepositoryInterface{
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  async createBugReport(dto: CreateBugReportRequestDTO): Promise<BugReportEntity> {
    const url = '/bug-report/bugs';
    const res = await this.axios.post(url, dto);

    return res.data;
  }

  async getBugReport(id: number): Promise<BugReportEntity> {
    const url = `/bug-report/bugs/${id}`;
    const res = await this.axios.get(url)

    return res.data;
  }

  async updateBugReport(id: number, dto: UpdateBugReportDTO): Promise<BugReportEntity> {
    const url = `/bug-report/bugs/${id}`;
    const res = await this.axios.patch(url, dto);

    return res.data;
  }

  async getFileConfig(): Promise<BugReportFilesConfig> {
    const url = `/bug-report/bugs/file-config`;
    const res = await this.axios.get(url)

    return res.data;
  }

  async removeFiles(id: number, fileIds: number[]): Promise<void> {
    const url = `/bug-report/bugs/${id}/files`;
    const res = await this.axios.delete(url, { params: {
      ids: fileIds,
      }});

    return res.data;
  }

  async deleteBugReport(id: number): Promise<void> {
    const url = `/bug-report/bugs/${id}`;
    await this.axios.delete(url);
  }

  async getAll(page?: number, take?: number): Promise<[BugReportEntity[], number]> {
    const url = `/bug-report/bugs?page=${page}&take=${take}`;
    const res = await this.axios.get(url);

    return res.data;
  }

  async search(
    filters: BugReportFiltersDTO,
    page?: number,
    take?: number,
    withDeleted?: boolean,
    deletedOnly?: boolean,
    ): Promise<[BugReportEntity[], number]> {
    if(filters.dateFrom) {
      Object.assign(filters, {dateFrom: new Date(filters.dateFrom).toISOString()})
    }
    if(filters.dateTo) {
      Object.assign(filters, {dateTo: new Date(filters.dateTo).toISOString()})
    }
    const url = `/bug-report/bugs/search?${this.transformDTO(filters)}&`
    const res = await this.axios.get(url, {
      params: {
        page,
        take,
        withDeleted,
        deletedOnly,
      }
    })

   return res.data;
  }

  async archive(page?: number, take?: number): Promise<[FeatureRequestEntity[], number]> {
    const url = `/bug-report/bugs/archive?page=${page}&take=${take}`;
    const res = await this.axios.get(url);

    return res.data
  }

  public transformDTO(filters: BugReportFiltersDTO): string {
    return Object.keys(filters).map((key) => {
      return `filters[${key}]=${filters[key as keyof BugReportFiltersDTO]}`
    }).join("&")
  }
}


